import React from 'react';
import ProjectGrid from '../components/ProjectGrid';
import projectsData from '../data/projectsData';

function Art() {
    const artProjects = projectsData.filter(project => project.category === 'Art');

    return (
        <div className="default-container">
            <h1>Art Projects</h1>
            <ProjectGrid projects={artProjects} />
        </div>
    );
}

export default Art;
